<template>
  <v-container fluid>
    <span>{{ $t("app.visit.planned-overview")}}</span>

    <v-container fluid class="d-flex flex-wrap justify-center align-stretch">
      <v-card
      v-for="patient in patients"
      :key="patient.id"
      class="d-flex flex-column justify-stretch ma-5"
      flat
    >
      <div class="img-container">
        <img
          v-if="!patient.profilePicture || !patient.profilePicture.blobUri"
          class="profile-picture"
          src="@/assets/images/nophoto.png"
        />
        <img
          v-else
          class="profile-picture"
          :src="patient.profilePicture.blobUri"
        />
      </div>
      <h3
        class="mt-3"
      >
        {{ patient.firstName }}
      </h3>
      <v-card-text class="flex-grow-1">
        <v-list>
          <v-list-item
            v-for="visit in visitsFor(patient)"
            :key="visit.id"
          >
            <v-list-item-content>
              <h3 class="my-1">{{ visit.dateTime | moment("DD MMM YYYY")}}</h3>
              <h3 class="pink--text my-1">{{ visit.dateTime | moment("HH:mm")}}</h3>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="justify-center" v-if="!visitsFor(patient).length">
        <a
          class="pink--text"
          @click="selectPatientForVisit(patient)"
        >
          {{ $t('app.visit.plan') }}
        </a>
      </v-card-actions>
    </v-card>
    </v-container>
  </v-container>
</template>

<script>
import {neoparentUsers, neoparentVisits} from "@/api";

export default {
  name: "neoparent-visitoverview",
  props: [],
  data() {
    return {
      patients: this.$store.getters.user.patients,
      visits: []
    };
  },
  mounted() {
    const that = this
    neoparentVisits.getAllForUser()
      .then(x => {
        that.visits = x.data.visits
      })
  },
  methods: {
    selectPatientForVisit(patient) {
      neoparentUsers.selectPatient(patient.id)
        .then(() => {
          window.location.href = "/visit"
        })
    },

    visitsFor(patient){
      return this.visits.filter(visit => visit.patient.id === patient.id)
    }
  },
};
</script>

<style scoped lang="scss">
/*form {
  position: relative;
}

.planned-visit {
  width: 90%;
  margin: 0 auto 5rem auto;

  .read-confirmation {
    display: block;
    font-style: italic;
  }
}

.planned-visit img {
  margin: -2rem 0;
  width: 75%;
}

.edit-visit-button {
  position: absolute;
}

.date {
  display: block;
}

.time {
  font-size: 48px;
}

.visit-message {
  // margin-bottom: 5rem;

  * {
    margin: 0.5rem;
  }
}*/
.img-container{
  width: 200px;
  height: 200px;
}

.profile-picture {
  object-fit: cover;
  border-radius: 50%;
  height: 100%
}
</style>
